import { Controller } from "@hotwired/stimulus";

function fmtCurrency(value) {
  if (!value) return "$0";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

function getSavings(value) {
  if (value >= 0 && value <= 99999) {
    return "$300";
  } else if (value >= 100000 && value <= 149999) {
    return "$650";
  } else if (value >= 150000 && value <= 199999) {
    return "$900";
  } else if (value >= 200000 && value <= 249999) {
    return "$1,150";
  } else if (value >= 250000 && value <= 299999) {
    return "$1,400";
  } else if (value >= 300000 && value <= 349999) {
    return "$1,750";
  } else if (value >= 350000 && value <= 399999) {
    return "$2,000";
  } else if (value >= 400000 && value <= 449999) {
    return "$2,300";
  } else if (value >= 450000 && value <= 499999) {
    return "$2,500";
  } else if (value >= 500000 && value <= 599999) {
    return "$3,100";
  } else if (value >= 600000 && value <= 699999) {
    return "$3,400";
  } else if (value >= 700000 && value <= 799999) {
    return "$4,000";
  } else if (value >= 800000 && value <= 899999) {
    return "$4,600";
  } else if (value >= 900000 && value <= 999999) {
    return "$5,000";
  } else if (value >= 1000000 && value <= 1999999) {
    return "$6,000";
  } else if (value >= 2000000 && value <= 2999999) {
    return "$7,500";
  } else if (value >= 3000000) {
    return "$8,000";
  }
  return "NA";
}

export default class extends Controller {
  static targets = ["savings", "slider", "housePrice"];
  static values = {
    default: Number,
    max: Number,
  };

  multiple = this.maxValue / 100;

  connect() {
    const value = this.defaultValue / this.multiple;
    this.sliderTarget.value = value;
    this.updateDisplayValues(this.defaultValue);
    this.updateSliderBackground(value);
    this.initSlider();
  }

  initSlider() {
    this.sliderTarget.addEventListener("input", (e) => {
      const value = parseInt(e.target.value);
      this.updateDisplayValues(value * this.multiple);
      this.updateSliderBackground(value);
    });
  }

  updateSliderBackground(value) {
    const progress = (value / 100) * 100;
    const style = `linear-gradient(to right, #3eb2ef ${progress}%, #f3f4f6 ${progress}%)`;
    this.sliderTarget.style.background = style;
  }

  updateDisplayValues(value) {
    this.housePriceTarget.textContent = fmtCurrency(value);
    this.savingsTarget.innerHTML = getSavings(value);
  }
}
